import { render } from "./RegisterFlow.vue?vue&type=template&id=cb80de80"
import script from "./RegisterFlow.vue?vue&type=script&lang=ts"
export * from "./RegisterFlow.vue?vue&type=script&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "cb80de80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cb80de80', script)) {
    api.reload('cb80de80', script)
  }
  
  module.hot.accept("./RegisterFlow.vue?vue&type=template&id=cb80de80", () => {
    api.rerender('cb80de80', render)
  })

}

script.__file = "src/components/registerTeam/RegisterFlow.vue"

export default script